import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArSiteSetupFormLockAccessCreatedNotifyApproversProps extends BaseTemplateProps {
  request: {
    name: string
    createdBy: {
      name: string
    }
  }
}

export const ArSiteSetupFormLockAccessCreatedNotifyApprovers: TemplateDefinition<ArSiteSetupFormLockAccessCreatedNotifyApproversProps> =
  {
    renderParams: (props: ArSiteSetupFormLockAccessCreatedNotifyApproversProps) => ({
      messageKey: 'notificationsDomain.templates.arSiteSetupFormLockAccessCreatedNotifyApprovers',
      values: {
        siteName: props?.request?.name,
        createdBy: props?.request?.createdBy?.name,
      },
    }),
    getLink: (props: ArSiteSetupFormLockAccessCreatedNotifyApproversProps): string => {
      if (!props) return ''
      return '/app/admin/approvals-management/approval-requests-search?tool=site_setup_admin_form_edit_access'
    },
  }
